module.exports = __webpack_public_path__ + "static/media/VU4210F1.1645f9cd.png";